export default [
  {
    MIN_POWER: 80,
    MAX_POWER: 60,
    MIN_REPAIR: 1200,
    MAX_REPAIR: 300,
    MIN_TOWN: 2,
    MAX_TOWN: 0.1,
    MIN_TOTAL: 1080,
    MAX_TOTAL: 350,
    MIN_SATISF: 50,
    MAX_SATISF: 95
  },
  {
    MIN_POWER: 25,
    MAX_POWER: 15,
    MIN_REPAIR: 1200,
    MAX_REPAIR: 490,
    MIN_TOWN: 4,
    MAX_TOWN: 0.8,
    MIN_TOTAL: 1400,
    MAX_TOTAL: 615,
    MIN_SATISF: 70,
    MAX_SATISF: 98
  },
  {
    MIN_POWER: 25,
    MAX_POWER: 16,
    MIN_REPAIR: 1200,
    MAX_REPAIR: 400,
    MIN_TOWN: 5,
    MAX_TOWN: 0.9,
    MIN_TOTAL: 1225,
    MAX_TOTAL: 366,
    MIN_SATISF: 60,
    MAX_SATISF: 99
  },
  {
    MIN_POWER: 30,
    MAX_POWER: 19,
    MIN_REPAIR: 1400,
    MAX_REPAIR: 500,
    MIN_TOWN: 5,
    MAX_TOWN: 0.9,
    MIN_TOTAL: 1650,
    MAX_TOTAL: 590,
    MIN_SATISF: 60,
    MAX_SATISF: 99
  }
]
